module.exports = __webpack_public_path__ + "static/trillion-dollar-coach-41a8f5bbde557532681322b9f6d25186.jpg";